<template>
  <detail-row-wrapper :save-function="submit" :cancel-function="cancel">
    <div class="contents-wrapper">
      <div class="main-contents">
        <detail-row-component title="생산자 이름" :inner-vertical="true">
          <layout-input v-model="editable.name" :regex="regex(1, 100).ko_num" placeholder="한글 이름을 입력해주세요." />

          <layout-input v-model="editable.nameEn" placeholder="영문 이름을 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="위도">
          <layout-input v-model="editable.latitude" :regex="regex(1, 1000).num_dot_minus" placeholder="위도를 입력해주세요."
            type="number" isFloat />
        </detail-row-component>

        <detail-row-component title="경도">
          <layout-input v-model="editable.longitude" :regex="regex(1, 1000).num_dot_minus" placeholder="경도를 입력해주세요."
            type="number" isFloat />
        </detail-row-component>

        <detail-row-component title="맵 확대 크기">
          <layout-input v-model="editable.mapZoom" placeholder="맵 확대 크기를 입력해주세요." />
        </detail-row-component>

        <detail-row-component title="와이너리 검색">
          <google-map class="detail-row-value" :lat="editable.latitude" :lng="editable.longitude"
            :map-zoom="editable.mapZoom" @onChangeLat="value => editable.latitude = value"
            @onChangeLng="value => editable.longitude = value" @onChangeMapZoom="value => editable.mapZoom = value" />
        </detail-row-component>

        <detail-row-component title="발행">
          <layout-switch-button v-model="editable.isChecked" />
        </detail-row-component>
      </div>
    </div>
  </detail-row-wrapper>
</template>

<script>
import { validate, multipleValidate, regex } from "@/utils/utils"
import DetailRowWrapper from "@/spa/components/detail-row/DetailRowWrapper"
import DetailRowComponent from "@/spa/components/detail-row/DetailRowComponent"
import LayoutInput from "@/spa/components/LayoutInput"
import LayoutSwitchButton from "@/spa/components/LayoutSwitchButton"
import GoogleMap from "./GoogleMap"

export default {
  name: "WineryEditor",
  components: {
    GoogleMap,
    LayoutInput,
    LayoutSwitchButton,
    DetailRowWrapper,
    DetailRowComponent
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    regex(min, max) {
      return regex(min, max)
    },
    async submit() {
      this.editable.id = this.rowData.id
      console.log("this.editable.latitude", this.editable.latitude)
      const validateResult = multipleValidate([
        validate({
          message: "생산자 한글 이름",
          target: this.editable.name,
          regex: this.regex(1, 100).ko_num
        }),
        // validate({
        //   message: "생산자 영문 이름",
        //   target: this.editable.nameEn,
        //   regex: this.regex(1, 100).en_num
        // }),
        validate({
          message: "위도",
          target: this.editable.latitude,
          regex: this.regex(1, 1000).num_dot_minus
        }),
        validate({
          message: "경도",
          target: this.editable.longitude,
          regex: this.regex(1, 1000).num_dot_minus
        })
      ])
      if (this.editable.isChecked && validateResult.flag) {
        this.$toast(validateResult.message)
        return
      }
      const result = await this.$store.dispatch("updateWinery", this.editable)
      if (result.response) {
        this.$table.updateField()
      }
      this.$toast(result.message)
    },
    cancel() {
      this.$table.updateField()
    }
  },
  data() {
    return {
      editable: {
        name: this.rowData.name,
        nameEn: this.rowData.name_en,
        latitude: this.rowData.latitude,
        longitude: this.rowData.longitude,
        mapZoom: this.rowData.map_zoom || 8,
        isChecked: this.rowData.is_checked
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contents-wrapper {
  position: relative;
  min-height: 600px;
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  flex-direction: row;

  .main-contents {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/winery/detail-row/WineryEditor.vue